<template>
        <v-card>
            <v-card-title class="text-h5" v-if="!isCreation">
                A(z) {{product_name}} termék szerkesztése
            </v-card-title>
            <v-card-title class="text-h5" v-else>
            Új termék létrehozása
            </v-card-title>
                <div class="ma-5">
                    <v-row>
                        <v-col cols="4">
                            <v-text-field
                                v-model="product_name"
                                label="Termék név"
                                clearable
                                outlined
                            ></v-text-field>
                            <v-select :items="types" item-text="name" item-value="id" :value="selected_type" label="Termék típusa"></v-select>
                            <DescriptionEditor ref="descriptionEditor" :contentRootData="descriptionText"/>
                            <v-file-input
                                label="Képek beszúrása"
                                multiple
                                outlined
                                small-chips
                            ></v-file-input>
                            <v-row>
                                <v-btn
                                    color="#920825"
                                    text
                                    @click="$emit('exit')"
                                >
                                    Mégsem
                                </v-btn>
                                <v-spacer></v-spacer>
                                <v-btn
                                    color="#920825"
                                    text
                                    @click="save()"
                                >
                                    Mentés
                                </v-btn>
                            </v-row>
                        </v-col>
                    </v-row>
                </div>
                <v-card-actions>
                
                </v-card-actions>
        </v-card>
</template>
<script>
import api from '@/util/api_util'
import DescriptionEditor from '@/components/DescriptionEditor'
export default {
    components:{
        DescriptionEditor
    },
    data(){
        return{
            product_name: "",
            description: "",
            selected_type: null,
            index_picture: "",
            isCreation: false,
            types: [
                {name: "Kültéri", id:1},
                {name: "Beltéri", id:2}
            ],
            descriptionText: "<p><strong>Rendeltetés</strong></p><p>Mérés-adatgyüjtő rendszerek primer műszereinek külső behatások</p><p>(időjárás, illetéktelen kezelés, idegenkezűség) elleni védelme.</p><p>Kialakítás</p><p>A szekrény felsőrészből (védett, fűtött tér) és alsórészből (lábazat) áll.</p><p>Mindkét rész belső tere elölről - ajtónyitás után - hozzá-férhető.</p><p>A felső szekrényrész háromféle méretben készül:</p><p><br></p><p>MI FC1 típusú 550£390£380mmMm (maxszéxmé)</p><p><br></p><p>HM&nbsp;FC2 típusú 550£550X380mmMm (maxszéxmé)</p><p><br></p><p>HM FC3 típusú 650X850Xx380mmMm (maxszéxmé)</p><p>A lábazat mindhárom nagyságnál azonos méretű 1050£390x250 mm</p><p>(maxszéxm</p>",

        }
    },
    props:{
        product_id:{ type: Number}
    },
    created(){
        if(this.product_id >=0){
            api.get("/item/"+this.product_id).then(response=>{
                console.log(response);
                    let datas = response.datas
                    this.product_name = datas.name;
                    this.description = datas.description;
                    this.selected_type = this.types.find((e)=> e.id == datas.type_id);
                    this.index_picture = datas.index_picture;
            })
        }
        else{
            this.isCreation = true;
        }        
    },
    methods:{
        save:function(){
            console.log(this.selected_type);
            this.description = this.$refs.descriptionEditor.content;
            console.log(this.description);
            let body = {
                    "name":this.product_name,
                    "description": this.description,
                    "type_id": this.selected_type.id,
                    "index_picture": this.index_picture,
                    "images": [],
                    "models": [],
                    "manuals": []
                };
            console.log(body);
            if(this.isCreation){
                api.post("/item/create",body).then(response=>{
                console.log(response);
            })
            }
            else{
                body["id"] = this.product_id;
                api.post("/item/update",body).then(response=>{
                console.log(response);
            })
            }
            
        }
    }
}
</script>
<style scoped>

</style>